export default __webpack_public_path__ + "static/media/Support.8ab4f866.jpg";